import { migrationAuthSelector } from '@store/migrationSelectors/authSelectors'
import {
  type DashboardActions,
  InternalProjectActions as Internal,
} from '@store/reducers/dashboard/actions'
import { call, put, select } from 'redux-saga/effects'

import API from '@/api'

// Уйти из проекта — это снять с себя членство, и такая ручка есть только в PHP:
// /members/:workspaceId/leave в octopus-api про воркспейсы, а не про проекты.
export function* leave({
  payload: { id },
}: ReturnType<typeof DashboardActions.projects.leave>) {
  const userId: string = yield select(migrationAuthSelector.getUserId)

  yield put(Internal.delete({ id }))

  // @ts-expect-error — api.js без типов, как и в соседних сагах
  yield call(API.Members.delete, { projectId: id, id: userId })
}
